export const UI_CONFIG = {
  MODAL_CLOSE_TIMEOUT: 500, // milliseconds
};
